/**
 * The left nav's expanded/collapsed preference (TMMPDM-0033, SHELL-004). A UI preference, never
 * a credential: the one sanctioned `localStorage` entry in this app, allowlisted by
 * `src/storage.guard.test.ts`. Storage can be unavailable (private mode, blocked site data), so
 * every access is guarded and the nav falls back to expanded.
 */
export const NAV_COLLAPSED_KEY = 'tmm_product_admin.navCollapsed';

export function readNavCollapsed(): boolean {
  try {
    return window.localStorage.getItem(NAV_COLLAPSED_KEY) === 'true';
  } catch {
    return false;
  }
}

export function writeNavCollapsed(collapsed: boolean): void {
  try {
    window.localStorage.setItem(NAV_COLLAPSED_KEY, String(collapsed));
  } catch {
    /* preference not persisted — the toggle still works for this session */
  }
}
